var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHostel = function SvgHostel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#789D4A",
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M13.311 29.363v-5.575m16.166-6.132L24.46 12.08l-5.017 5.575v11.149h10.034zm-3.344 6.132c0-.848-.652-1.673-1.672-1.673s-1.673.803-1.673 1.673v5.017h3.345zM13.311 18.77a2.787 2.787 0 0 1 2.787 2.788v2.23a2.787 2.787 0 1 1-5.575 0v-2.23a2.787 2.787 0 0 1 2.788-2.788Z"
  })));
};
export default SvgHostel;